import { UserRoles } from '@/constants/UserRoles';
import { SetupSplitService } from '@/services/setupSplitService';
import { defineStore } from 'pinia';

/**
 * Se o usuário logado vê a Carteira (Financeiro > Carteira).
 *
 * Quem decide é o backend (parceiro no piloto do split, flag de texto no ConfigCat), e não o
 * ConfigCat do front: é a mesma fonte que libera a leitura da carteira, então o menu nunca mostra
 * um item que dá 404. Qualquer falha esconde o item; a próxima montagem do menu tenta de novo.
 */
export const WalletStore = defineStore('wallet', {
	state: () => ({
		enabled: false,
		/** Usuário para quem o acesso já foi consultado. Troca de usuário consulta de novo. */
		loadedFor: '',
	}),

	actions: {
		async load(userId: string, role: string) {
			if (!userId || this.loadedFor === userId) return;

			this.loadedFor = userId;
			this.enabled = false;

			if (!UserRoles.BrokerRoles.includes(role)) return;

			try {
				const access = await SetupSplitService.getWalletAccess();
				if (this.loadedFor === userId) this.enabled = access.enabled === true;
			} catch {
				if (this.loadedFor === userId) this.loadedFor = '';
			}
		},
	},
});

export default WalletStore;
